import {callSP} from 'setup/axios/AxiosCallSP'
import {
  IContractData,
  IExcelData,
  IFixedRecipe,
  IFixedStructure,
  IIngredientFrequency,
  IRules,
  IStructure,
  IWeekDays,
} from '../excelToJson/IExcel'
import {IResponseCallSP} from 'setup/responce.interface'
import {AlertModalProps} from 'app/utils/modal/AlertModal'

const nowDate = new Date().toISOString()
const totalServices: number = 8
let totalServicesCount: number = 0

type ContractStorage = {
  [place: string]: {
    [regime: string]: {
      [service: string]: string
    }
  }
}
type StructureContractStorage = {
  [idContract: string]: {
    [idChildStructure: string]: string
  }
}
let arrayStorageIdContract: ContractStorage[] = []
let arrayStructureContract: StructureContractStorage[] = []
let allContracts: string[] = []

const paramsCreateContact = (item: IContractData) => [
  {text: 'id', value: '0'},
  {text: 'id_sitio', value: item.Cod_Sitio},
  {text: 'id_tipo_servicio', value: item['Servicio Código']},
  {text: 'id_regimen', value: item['Regimen Código']},
  {text: 'costo_objetivo_mensual', value: item.Costo_Objetivo},
  {text: 'ciclo_minuta', value: item.Ciclos_Minuta},
  {text: 'ciclo_plantilla', value: item['Ciclo Plantilla (dias x semanas)']},
  {text: 'ciclos', value: item['Ciclos (Semanas']},
  {text: 'fecha_creacion', value: nowDate},
  {
    text: 'id_tipo_plantilla',
    value: item['Tipo_Plantilla (Rotativa = 1, Fija = 2, No rotativa = 3)'],
  },
  {text: 'id_tipo_frecuencia', value: item['Tipo_Frecuencia sodexo = 0, contractual = 1']},
  {text: 'id_contr_rel', value: '0'},
]

export const createContract = async (
  dataExcel: IExcelData,
  setAlertModal: React.Dispatch<React.SetStateAction<AlertModalProps | undefined>>
): Promise<void> => {
  allContracts = []
  totalServicesCount = 0
  arrayStructureContract = []
  arrayStorageIdContract = []
  const data = dataExcel.Datos_contrato || []
  const promises = data.map(async (item) => {
    try {
      const result: IResponseCallSP = await callSP(
        'amd_insertContratoServicio',
        paramsCreateContact(item)
      )
      addContractToStorage(
        item.Cod_Sitio.toString(),
        item['Regimen Código'].toString(),
        item['Servicio Código'].toString(),
        result.data.result[0]?.idcontrato.toString()
      )
    } catch (error) {
      console.error('Error al procesar el contrato:', item, error)
    }
  })
  await Promise.allSettled(promises)
  console.log('Se finalizo el proceso de amd_insertContratoServicio' + getServiceTotalService())
  await createWeekDays(dataExcel, setAlertModal)
}

const getServiceTotalService = () => {
  totalServicesCount++
  return ` se ha procesado ${totalServicesCount} de ${totalServices}`
}

const paramsWeekDays = (item: IWeekDays, contractId: string) => [
  {text: 'id', value: '0'},
  {text: 'id_contrato', value: contractId},
  {text: 'dia', value: item['Numero Dia']},
  {text: 'estado', value: parseFloat(item.Comensales.toString()) > 0 ? '1' : '0'},
  {text: 'q_comensales', value: item.Comensales.toString()},
  {text: 'n_dia', value: item['Numero Dia']},
]

const createWeekDays = async (
  dataExcel: IExcelData,
  setAlertModal: React.Dispatch<React.SetStateAction<AlertModalProps | undefined>>
): Promise<void> => {
  const data = dataExcel.Dias_semanas || []
  const promises = data.map(async (item) => {
    try {
      const contractId = getContractId(
        item.Cod_Sitio.toString(),
        item['Regimen Código'].toString(),
        item['Servicio Código'].toString()
      )
      if (contractId !== '') {
        const result: IResponseCallSP = await callSP(
          'amd_insertDiaSemanaContrato',
          paramsWeekDays(item, contractId)
        )
      } else {
        console.error(
          `El contrato código sitio ${item.Cod_Sitio}, régimen código ${item['Regimen Código']} y servicio código no se pudo crear el contrato`
        )
      }
    } catch (error) {
      console.error(
        `El contrato código sitio ${item.Cod_Sitio}, régimen código ${item['Regimen Código']} y el servicio código ${item['Servicio Código']} no se pudo crear el contrato`
      )
    }
  })
  await Promise.allSettled(promises)
  console.log('Se finalizo el proceso de amd_insertDiaSemanaContrato' + getServiceTotalService())
  await createStructure(dataExcel, setAlertModal)
}

const paramsStructure = (item: IStructure, contractId: string) => [
  {text: 'id', value: '1'},
  {text: 'id_contrato', value: contractId},
  {text: 'id_servicio', value: item['Servicio Código']?.toString() || ''},
  {text: 'id_estructura', value: item['Macro_Estructura código']?.toString() || ''},
  {text: 'id_estilo_aliminatacion', value: '3'},
  {text: 'id_sellos', value: '2'},
  {text: 'id_intolerancia', value: item.Intolerancias?.toString() || ''},
  {text: 'id_alergeno', value: item.Alergenos?.toString() || ''},
  {text: 'id_categoria_dietetica', value: item['Categoria_Dietetica código']?.toString() || ''},
  {text: 'estructura', value: item['Estructura nombre']?.toString() || ''},
  {text: 'relacion', value: '0'},
  {text: 'diasBloqueados', value: item['Dias Bloqueados']?.toString() || ''},
  {text: 'tipo_plato', value: item.Tipo_Plato?.toString() || ''},
  {text: 'id_estructura_hijo', value: item['Estructura código']?.toString() || ''},
  {text: 'order', value: item.Orden?.toString() || ''},
  {text: 'id_est_rel', value: '0'},
]

const createStructure = async (
  dataExcel: IExcelData,
  setAlertModal: React.Dispatch<React.SetStateAction<AlertModalProps | undefined>>
): Promise<void> => {
  const data = dataExcel.Estructura || []
  const promises = data.map(async (item) => {
    const contractId = getContractId(
      item.Cod_Sitio.toString(),
      item['Regimen Código'].toString(),
      item['Servicio Código'].toString()
    )
    try {
      const result: IResponseCallSP = await callSP(
        'amd_insertEstructuraContratoBatch',
        paramsStructure(item, contractId)
      )
      if (result.data.result.length > 0) {
        arrayStructureContract.push(result.data.result[0].id)
        console.warn(contractId, item['Estructura código'], result.data.result[0].id)
        addIdStructureContract(contractId, item['Estructura código'], result.data.result[0].id)
      }
    } catch (error) {
      console.error(
        `El contrato código sitio ${item.Cod_Sitio}, régimen código ${item['Regimen Código']} y servicio código no se pudo crear la estructura:`,
        error
      )
    }
  })
  await Promise.allSettled(promises)
  console.log(
    'Se finalizó el proceso de amd_insertEstructuraContratoBatch' + getServiceTotalService()
  )
  await createFixedStructure(dataExcel, setAlertModal)
}

const paramsFixedStructure = (item: IFixedStructure, contractId: string) => [
  {text: 'id', value: '1'},
  {text: 'id_contrato', value: contractId?.toString() || ''},
  {text: 'id_grupo_estructura', value: item['Código Grupo estructura']?.toString() || ''},
  {text: 'id_est_rel', value: '0'},
  {text: 'id_receta', value: item['Cod_Receta código']?.toString() || ''},
]

const createFixedStructure = async (
  dataExcel: IExcelData,
  setAlertModal: React.Dispatch<React.SetStateAction<AlertModalProps | undefined>>
): Promise<void> => {
  const data = dataExcel.Estructura_Fija || []
  const promises = data.map(async (item) => {
    const contractId = getContractId(
      item.Cod_Sitio.toString(),
      item['Regimen Código'].toString(),
      item['Servicio Código'].toString()
    )
    try {
      if (contractId !== '') {
        const result = await callSP(
          'amd_insertEstructuraFija',
          paramsFixedStructure(item, contractId)
        )
      } else {
        throw new Error(
          `No se pudo obtener el ID del contrato para el sitio ${item.Cod_Sitio}, régimen código ${item['Regimen Código']}`
        )
      }
    } catch (error) {
      console.error(
        `La estructura código fija con sitio ${item.Cod_Sitio}, régimen código ${item['Regimen Código']} no pudo ser creada:`,
        error
      )
    }
  })
  await Promise.allSettled(promises)
  console.log('Se finalizó el proceso de amd_insertEstructuraFija' + getServiceTotalService())
  await createFixedRecipe(dataExcel, setAlertModal)
}

const paramsFixedRecipe = (item: IFixedRecipe, contractId: string, structureId: string) => [
  {text: 'id_estructura_contrato', value: structureId?.toString() || '0'},
  {text: 'id_receta', value: item.receta?.toString() || ''},
  {text: 'id_ingrediente_principal', value: item.Ingrediente_Principal},
  {text: 'dia_ciclo', value: item['dia num']},
  {text: 'ciclo ', value: item.Semana},
  {text: 'intercalado ', value: '1'},
  {text: 'id_categoria_dietetica ', value: item.Categoria_Dietetica},
]

const createFixedRecipe = async (
  dataExcel: IExcelData,
  setAlertModal: React.Dispatch<React.SetStateAction<AlertModalProps | undefined>>
): Promise<void> => {
  const data = dataExcel.Receta_Fija || []
  const promises = data.map(async (item) => {
    const contractId = getContractId(
      item.Cod_Sitio.toString(),
      item['Regimen Código'].toString(),
      item['Servicio Código'].toString()
    )
    try {
      const structureId = getEstructureId(contractId, item.estructura)
      const result = await callSP(
        'amd_insertRecetaFija',
        paramsFixedRecipe(item, contractId, structureId)
      )
    } catch (error) {
      console.error(
        `La receta fija con código fija con sitio ${item.Cod_Sitio}, régimen código ${item['Regimen Código']} no pudo ser creada:`,
        error
      )
    }
  })
  await Promise.allSettled(promises)
  console.log('Se finalizo el proceso de amd_insertRecetaFija' + getServiceTotalService())
  await createFrequencyIngredients(dataExcel, setAlertModal)
}

const paramsFrequencyIngredients = (
  item: IIngredientFrequency,
  contractId: string,
  structureId: string
) => [
  {text: 'id_estructura_contrato', value: structureId?.toString() || '0'},
  {text: 'id_ingrediente_principal', value: item['Ingrediente_Principal código']},
  {text: 'id_categoria_dietetica', value: item.id_cat_dietetica},
  {text: 'cantidad_frecuencia', value: item.Frecuencia},
  {text: 'semana', value: item.Semanas},
  {
    text: 'comodin',
    value: item['Comodin (solo no rotativos)'] ? item['Comodin (solo no rotativos)'] : '0',
  },
]

const createFrequencyIngredients = async (
  dataExcel: IExcelData,
  setAlertModal: React.Dispatch<React.SetStateAction<AlertModalProps | undefined>>
): Promise<void> => {
  const promises =
    dataExcel.Frecuencia_Ingredientes?.map(async (item) => {
      const contractId = getContractId(
        item.Cod_Sitio.toString(),
        item['Regimen Código'].toString(),
        item['Servicio Código'].toString()
      )
      const structureId = getEstructureId(contractId, item['Estructura código'])
      if (contractId !== '') {
        try {
          const result = await callSP(
            'amd_insertFrecuenciaContrato',
            paramsFrequencyIngredients(item, contractId, structureId)
          )
        } catch (error) {
          console.error(error)
          console.error(
            `la receta fija con código fija con sitio ${item.Cod_Sitio}, regimen código ${item['Regimen Código']} no pudo ser creada`
          )
        }
      } else {
        console.error(
          `la receta fija con código fija con sitio ${item.Cod_Sitio}, regimen código ${item['Regimen Código']} no pudo ser creada`
        )
      }
    }) || []
  await Promise.allSettled(promises)
  console.log('Se finalizo el proceso de amd_insertFrecuenciaContrato' + getServiceTotalService())
  await finishedCreationsContract(dataExcel, setAlertModal)
}

const finishedCreationsContract = async (
  dataExcel: IExcelData,
  setAlertModal: React.Dispatch<React.SetStateAction<AlertModalProps | undefined>>
): Promise<void> => {
  for (const item of allContracts) {
    try {
      const result = await callSP('amd_insertFrecuenciaByContrato', [
        {text: 'contrato', value: item?.toString() || ''},
      ])
    } catch (error) {
      console.error(error)
    }
  }
  console.log('Se finalizo el proceso de amd_insertFrecuenciaByContrato' + getServiceTotalService())
  await createInsertStateContract(dataExcel, setAlertModal)
}
const paramsCreateInsertStateContract = (
  item: IRules,
  contractId: string,
  regla: string,
  estado: string
) => [
  {text: 'id_contrato', value: contractId?.toString() || '0'},
  {text: 'regla', value: regla.toString()},
  {text: 'estado', value: estado.toString()},
  {
    text: 'sitio',
    value: regla.toString() == '9' && estado.toString() == '1' ? item.Cod_Sitio2.toString() : '0',
  },
  {
    text: 'regimen',
    value:
      regla.toString() == '9' && estado.toString() == '1' ? item['Regimen Código'].toString() : '0',
  },
  {
    text: 'servicio',
    value:
      regla.toString() == '9' && estado.toString() == '1'
        ? item['Servicio Código'].toString()
        : '0',
  },
]
const createInsertStateContract = async (dataExcel: IExcelData, setAlertModal: any) => {
  const data: IRules[] = dataExcel.Reglas || []
  const getState = {
    'Distribución homogénea de colores (Prendida 1, Apagado 0)': 1,
    'Costo Descriptivo (Prendido 1, Apagado 0)': 2,
    'Repetición Nombre (Prendido 1, Apagado 0)': 3,
    'Complejidad Recetas (Prendido 1, Apagado 0)': 4,
    'Repetición Receta (Prendido 1, Apagado 0)': 5,
    'Cruce Garnitura (Prendido 1, Apagado 0)': 6,
    'Efecto Meteorizarte (Prendido 1, Apagado 0)': 7,
    'Método de Cocción (Prendido 1, Apagado 0)': 8,
    'Regla cruzada  (Prendido 1, Apagado 0) llenar las siguientes columans (Q,R,S,T,U,V) solo si esta regla esta prendida': 9,
  }
  try {
    const promises = data.map(async (item) => {
      const contractId = getContractId(
        item.Cod_Sitio.toString(),
        item['Regimen Código'].toString(),
        item['Servicio Código'].toString()
      )

      if (contractId) {
        for (const [estado, regla] of Object.entries(getState)) {
          try {
            const value = item[estado as keyof IRules] || '9';
            const params = paramsCreateInsertStateContract(
              item,
              contractId,
              regla.toString(),
              value
            )
            console.warn('params===>', params)

            await callSP('amd_insertEstadoReglasContrato', params)
          } catch (error) {
            console.error(`Error procesando regla: ${estado} para el contrato ${contractId}`, error)
          }
        }
      } else {
        throw new Error(
          `No se pudo obtener el ID del contrato para el sitio ${item.Cod_Sitio}, régimen código ${item['Regimen Código']}`
        )
      }
    })

    await Promise.allSettled(promises)
    console.log(
      'Se finalizó el proceso de amd_insertEstadoReglasContrato ' + getServiceTotalService()
    )

    setAlertModal({
      message: 'Se ha finalizado el proceso de creación de contratos',
      title: 'Proceso finalizado',
      closeName: '',
      showClose: false,
      close: () => setAlertModal(undefined),
      save: () => setAlertModal(undefined),
    })
  } catch (error) {
    console.error('Error general durante el proceso:', error)
  } finally {
    console.timeEnd()
  }
}

/*
const createFixedStructure = async (dataExcel: IExcelData, setAlertModal: React.Dispatch<React.SetStateAction<AlertModalProps | undefined>>): Promise<void> => {
    const data = dataExcel.Estructura_Fija || [];
    const promises = data.map(async item => {
        const contractId = getContractId(item.Cod_Sitio.toString(), item["Regimen Código"].toString(), item["Servicio Código"].toString());
        try {
            if (contractId !== '') {
                const result = await callSP('amd_insertEstructuraFija', paramsFixedStructure(item, contractId));
                // console.log("amd_insertEstructuraFija",result.data.result);
            } else {
                throw new Error(`No se pudo obtener el ID del contrato para el sitio ${item.Cod_Sitio}, régimen código ${item["Regimen Código"]}`);
            }
        } catch (error) {
            console.error(`La estructura código fija con sitio ${item.Cod_Sitio}, régimen código ${item["Regimen Código"]} no pudo ser creada:`, error);
        }
    });
    await Promise.allSettled(promises);
    console.log('Se finalizó el proceso de amd_insertEstructuraFija' + getServiceTotalService());
    await createFixedRecipe(dataExcel, setAlertModal);
};
*/
const addContractToStorage = (
  placeCode: string,
  regimeCode: string,
  serviceCode: string,
  idContract: string
): void => {
  const newStorage: ContractStorage = {
    [placeCode]: {
      [regimeCode]: {
        [serviceCode]: idContract,
      },
    },
  }
  allContracts.push(idContract.toString())
  arrayStorageIdContract.push(newStorage)
}

const addIdStructureContract = (
  idContract: string,
  idChildContract: string,
  idStructure: string
) => {
  const newStorage: StructureContractStorage = {
    [idContract]: {
      [idChildContract]: idStructure,
    },
  }
  arrayStructureContract.push(newStorage)
}
const getContractId = (placeCode: string, regimeCode: string, serviceCode: string): string => {
  const targetStorage = arrayStorageIdContract.find(
    (s) => s[placeCode] && s[placeCode][regimeCode] && s[placeCode][regimeCode][serviceCode]
  )
  return targetStorage ? targetStorage[placeCode][regimeCode][serviceCode].toString() : ''
}
const getEstructureId = (cotractId: string, estructureId: string): string => {
  const targetStorage = arrayStructureContract.find(
    (s) => s[cotractId] && s[cotractId][estructureId]
  )
  return targetStorage ? targetStorage[cotractId][estructureId]?.toString() || '' : ''
}
